var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 2.66699H5.33268C3.85992 2.66699 2.66602 3.8609 2.66602 5.33366V10.667C2.66602 12.1398 3.85992 13.3337 5.33268 13.3337H26.666C28.1388 13.3337 29.3327 12.1398 29.3327 10.667V5.33366C29.3327 3.8609 28.1388 2.66699 26.666 2.66699Z",
    stroke: "#C32B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 18.667H5.33268C3.85992 18.667 2.66602 19.8609 2.66602 21.3337V26.667C2.66602 28.1398 3.85992 29.3337 5.33268 29.3337H26.666C28.1388 29.3337 29.3327 28.1398 29.3327 26.667V21.3337C29.3327 19.8609 28.1388 18.667 26.666 18.667Z",
    stroke: "#C32B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H8.0125",
    stroke: "#C32B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H8.0125",
    stroke: "#C32B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.cd80f903daebf3d1697846c2a4bc6c76.svg";
export { ForwardRef as ReactComponent };